import { render, staticRenderFns } from "./del-folder.vue?vue&type=template&id=30787b73"
import script from "./del-folder.vue?vue&type=script&lang=js"
export * from "./del-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports